
function Close() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="77" height="77" viewBox="0 0 77 77" fill="none">
  <path d="M38.0119 4.75232C19.4806 4.75232 4.75061 19.4823 4.75061 38.0136C4.75061 56.5449 19.4806 71.2749 38.0119 71.2749C56.5432 71.2749 71.2732 56.5449 71.2732 38.0136C71.2732 19.4823 56.5432 4.75232 38.0119 4.75232ZM50.8412 54.6442L38.0119 41.8149L25.1825 54.6442L21.3813 50.843L34.2106 38.0136L21.3813 25.1842L25.1825 21.383L38.0119 34.2123L50.8412 21.383L54.6425 25.1842L41.8132 38.0136L54.6425 50.843L50.8412 54.6442Z" fill="#84BD00"/>
</svg>


  );
}

export default Close;
